export const appendCDN = () => {
    return new Promise((resolve, reject) => {

        let script = document.createElement('script')

        script.type = 'text/javascript'
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/5.0.1/js/bootstrap.bundle.min.js'
        document.body.appendChild(script)

        resolve()
    })
}


// WEBPACK FOOTER //
// ./src/utils/dist/index.js